import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import {AiFillEye, AiFillEyeInvisible} from "react-icons/ai";
import { Colors, Spacing, Typography } from '_styles';

const PasswordInput = (props) => {
    
    const [show, setShow] = useState(false);

    const showPassword = () => {
        setShow(true)
    }
    
    const hidePassword = () => {
        setShow(false)
    }

    return (
        <div style={{display:'flex'}}>
            <Form.Control onChange={(e) => props.setPassword(e.target.value)} type={show == false ? 'password' : 'text'} placeholder="Password" />
            {
                show == true ?
                    <AiFillEye size={30} style={{cursor:'pointer', marginTop:2, marginLeft:4}} color={Colors.PRM_LIGHT_BLUE} onClick={hidePassword} />
                :
                    <AiFillEyeInvisible size={30} style={{cursor:'pointer', marginTop:2, marginLeft:4}} color={'grey'} onClick={showPassword} />
            }
        </div>
    );
}

export default PasswordInput;